import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { contact_number, ImageUrl } from '../../../../../../Helpers/request';
import ShowroomImg from '../../assets/images/s-1.jpg'
import { Row, Col, Container } from 'react-bootstrap';
import '../../../../../../Assets/css/services.css'
import appraisals from '../../assets/images/services/appraisals.png'
import diamonds from '../../assets/images/services/diamonds.png'
import cleaning from '../../assets/images/services/jewelry-cleaning.png'
import webuy from '../../assets/images/services/we-buy-our-diamond-and-gold.png'
import repaire from '../../assets/images/services/jewelry-repaire.png'
import trade from '../../assets/images/services/trade-up.png'
import da from '../../assets/images/services/da-box.png'
import { isDesktop, isMobile, isMobileOnly } from 'react-device-detect';
import Slider from 'react-slick';


const servicesData = [
    { id: 1, title: "Appraisals", img: appraisals },
    { id: 2, title: "Diamonds", img: diamonds },
    { id: 3, title: "Jewelry Cleaning", img: cleaning },
    { id: 4, title: "Jewelry Repair", img: repaire },
    { id: 5, title: "We Buy Your Diamonds and Gold", img: webuy },
    { id: 6, title: "Trade Up Timepiece", img: trade },
    { id: 7, title: "DA BOX Concierge Service", img: da },
];


const ServiceOffered = () => {
    const topRow = servicesData.slice(0, 4);   // first 4 items
    const bottomRow = servicesData.slice(4, 7);

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2200,
    slidesToShow: 2,
    slidesToScroll: 1,
     responsive: [
    {
      breakpoint: 1024, // Tablet / Small laptop
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
     {
      breakpoint: 991, // Mobile
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
         dots: true,
          arrows: false,
      },
    },
    {
      breakpoint: 767, // Mobile
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         dots: true,
          arrows: true,
      },
    },
  ],
  };


    return (
        // <section className='service_offered'>
        //     <Container>
        //         <div className='title-box text-center mb-5'>
        //             <h2>Services We Offer</h2>
        //         </div>

        //         <Row className="services">
        //             <Col lg={6} className='text-center'>
        //                 <div>
        //                     <img src={ShowroomImg} alt="Show Room image" className='img-fluid' />
        //                 </div>
        //             </Col>

        //             <Col lg={6} className='text-center'>
        //                 <h2 className="title32">Jewelry Store on the corner of Congress and Fleet Street Portsmouth, NH</h2>
        //                 <p><strong>Our services include:</strong></p>
        //                 <hr className='my-3' />
        //                 <Row className="list-row text-left" >
        //                     <Col sm={6}>
        //                         <ul>
        //                             <li>Appraisals</li>
        //                             <li>Diamonds</li>
        //                             <li>Jewelry Cleaning</li>
        //                             <li>Jewelry Repair</li>
        //                         </ul>
        //                     </Col>
        //                     <Col sm={6}>
        //                         <ul>
        //                             <li>We Buy Your Diamonds and Gold</li>
        //                             <li>Trade Up Timepiece</li>
        //                             <li>DA BOX Concierge Service</li>
        //                         </ul>
        //                     </Col>
        //                 </Row>
        //             </Col>
        //         </Row>
        //     </Container>
        // </section >
        <div className='whitebox_services_section'>
        <Container className='container-whitebox'>
            <div className="services-section">
                {/* LEFT COLUMN */}
                <div className="services-left">
                    <div className='title-box text-center text-lg-left mb-5'>
                       {isDesktop ? <h2>Services <br /> We Offer</h2>: <h2>Services We Offer</h2>}
                          {isDesktop ? <p>Jewelry Store on the corner<br />
                            of Congress and Fleet Street<br />
                            Portsmouth, NH</p> : <p>Jewelry Store on the corner of Congress and Fleet Street Portsmouth, NH</p>}
                    </div>

                    {/* 4th Card Goes Here */}
                 { !isMobile &&   <div className="service-card">
                        <img src={servicesData[3].img} alt={servicesData[3].title} />
                        <span>{servicesData[3].title}</span>
                    </div>}
                </div>

                {isMobile ? (
            <Slider {...sliderSettings} className='services_slider'>
              {servicesData.map((item) => (
                <div className='mobile_slide_outer'>
                <div key={item.id} className="service-card mobile-slide">
                  <img src={item.img} alt={item.title} />
                  <span>{item.title}</span>
                </div>
                </div>
              ))}
            </Slider>
          ) : (
             
                <div className="services-right">
                    {servicesData.slice(0, 3).map((item) => (
                        <div className="service-card" key={item.id}>
                            <img src={item.img} alt={item.title} />
                            <span>{item.title}</span>
                        </div>
                    ))}

                    {servicesData.slice(4).map((item) => (
                        <div className="service-card" key={item.id}>
                            <img src={item.img} alt={item.title} />
                            <span>{item.title}</span>
                        </div>
                    ))}
                </div>
          )}

               

            </div>
        </Container>
        </div>
    )
}

export default ServiceOffered;